var base;

require('core-js/fn/array/find');

require('core-js/fn/array/find-index');

require('core-js/fn/object/keys');

require('core-js/fn/object/entries');

require('core-js/fn/object/assign');

require('core-js/fn/object/values');

require('core-js/fn/string/includes');

require('picturefill');

require('dom4');

document.head || (document.head = document.getElementsByTagName('head')[0]);

(base = window.location).origin || (base.origin = window.location.protocol + "//" + window.location.host);


/*
 * Chrome requestIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.requestIdleCallback = window.requestIdleCallback || function(cb) {
  return setTimeout((function() {
    var start;
    start = Date.now();
    return cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }), 1);
};


/*
 * Chrome cancelIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
  return clearTimeout(id);
};

Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9jb3JlL2RvbV9qc19zaGltLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9zcmMvZnJvbnRlbmQvY29yZS9kb21fanNfc2hpbS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxPQUFBLENBQVEsdUJBQVI7O0FBQ0EsT0FBQSxDQUFRLDZCQUFSOztBQUNBLE9BQUEsQ0FBUSx3QkFBUjs7QUFDQSxPQUFBLENBQVEsMkJBQVI7O0FBQ0EsT0FBQSxDQUFRLDBCQUFSOztBQUNBLE9BQUEsQ0FBUSwwQkFBUjs7QUFDQSxPQUFBLENBQVEsNEJBQVI7O0FBQ0EsT0FBQSxDQUFRLGFBQVI7O0FBRUEsT0FBQSxDQUFRLE1BQVI7O0FBR0EsUUFBUSxDQUFDLFNBQVQsUUFBUSxDQUFDLE9BQVMsUUFBUSxDQUFDLG9CQUFULENBQThCLE1BQTlCLENBQXNDLENBQUEsQ0FBQTs7UUFHeEQsTUFBTSxDQUFDLFNBQVEsQ0FBQyxlQUFELENBQUMsU0FBVyxNQUFNLENBQUMsUUFBUSxDQUFDLFFBQWhCLEdBQTJCLElBQTNCLEdBQWtDLE1BQU0sQ0FBQyxRQUFRLENBQUM7OztBQUc3RTs7OztBQUdBLE1BQU0sQ0FBQyxtQkFBUCxHQUE2QixNQUFNLENBQUMsbUJBQVAsSUFBOEIsU0FBQyxFQUFEO1NBQ3pELFVBQUEsQ0FBVyxDQUFDLFNBQUE7QUFDVixRQUFBO0lBQUEsS0FBQSxHQUFRLElBQUksQ0FBQyxHQUFMLENBQUE7V0FDUixFQUFBLENBQ0U7TUFBQSxVQUFBLEVBQVksS0FBWjtNQUNBLGFBQUEsRUFBZSxTQUFBO2VBQUcsSUFBSSxDQUFDLEdBQUwsQ0FBUyxDQUFULEVBQVksRUFBQSxHQUFLLENBQUMsSUFBSSxDQUFDLEdBQUwsQ0FBQSxDQUFBLEdBQWEsS0FBZCxDQUFqQjtNQUFILENBRGY7S0FERjtFQUZVLENBQUQsQ0FBWCxFQU1HLENBTkg7QUFEeUQ7OztBQVMzRDs7OztBQUdBLE1BQU0sQ0FBQyxrQkFBUCxHQUE0QixNQUFNLENBQUMsa0JBQVAsSUFBNkIsU0FBQyxFQUFEO1NBQVEsWUFBQSxDQUFhLEVBQWI7QUFBUjs7QUFHekQsS0FBSyxDQUFBLFNBQUUsQ0FBQSxJQUFQLEdBQWMsU0FBQyxJQUFELEVBQU8sRUFBUDtFQUNaLElBQUksQ0FBQyxNQUFMLENBQVksRUFBWixFQUFnQixDQUFoQixFQUFtQixJQUFJLENBQUMsTUFBTCxDQUFZLElBQVosRUFBa0IsQ0FBbEIsQ0FBcUIsQ0FBQSxDQUFBLENBQXhDO0FBQ0EsU0FBTztBQUZLIn0=
